export const GREEN = 'green';
export const GRAY = 'gray';
export const RED = 'red';
export const BLUE = 'blue';
export const BROWN = 'brown';
